// This is just an example,
// so you can safely delete all default props below

export default {
    forget_password: 'Forgot password',
    email: 'Email',
    send: 'Send',
    succeeded: 'Email sent successfully',
    failed: 'Failed',
    desc: 'Enter your registered email address. You will receive an e-mail to the registered address so that you can set a new password.'
}
